import { Status } from '@Components/Base';

import styles from './approval-status-item.module.css';

interface ApprovalStatusItemProps {
  requestsValueStatuses: number;
  statusText: 'PENDING' | 'OPEN' | 'APPROVED' | 'DECLINED';
}

const ApprovalStatusItem: React.FC<ApprovalStatusItemProps> = ({
  requestsValueStatuses,
  statusText,
}) => {
  return (
    <div className={styles.statusesItem}>
      <div>
        <Status className={styles.statusText} text={statusText.toLowerCase()} />
      </div>
      <div className={styles.statusText}>{requestsValueStatuses}</div>
    </div>
  );
};

export default ApprovalStatusItem;
